import React, { PureComponent, Component } from 'react'

import Dialog from '@material-ui/core/Dialog'
import TextField from '@material-ui/core/TextField'

import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import SelectList from '../SelectList'
import { alertActions } from '../../actions/alert.actions';
import { getFirebase } from 'react-redux-firebase'
import { dockPadEntityMapToList } from '../../containers/DockPadFormTemplates';
import { ConstraintStatus } from '../../utils/ConstraintStatus';
import { getNewId } from '../../actions/home.actions';
import { LookaheadTag, LookaheadTagStatus } from '../../models/LookaheadTag';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { Trade } from '../../models/Trade';
import moment, { Moment } from 'moment'
import { DatePicker } from "material-ui-pickers";
import classNames from 'classnames';

const _ = require('lodash')

interface IFormLookaheadTag {
    tradeId: string | null,
    name: string | null,
    locationId: string | null,
    predecessorId: string | null,
    crewSize: number,
    goal: string | null,
    status: LookaheadTagStatus,
    isMilestone: boolean | null
}

interface Props {
    tagToEdit: LookaheadTag,
    tagToEditId: string,
    isLookaheadTagDialogOpen: boolean,
    isNewTag: boolean,
    classes: ClassNameMap;
    closeTagDialogValue: () => Promise<void>;
    tradesSelectList: Record<string, string>;
    tagSelectList: Record<string, string>;
    trades: Record<string, Trade>;
    submitTagValue: (tag: LookaheadTag, constraint: object, tagId: string | null, tagDate?: string | null, row?: number | null, duration?: number | null) => Promise<void>;
    errorAlert: (message:string) => Promise<void>
    tagDate?: string | null
    row?: string | null,
    isAdmin: boolean;
	userTrades: Set<string>;

}

type State = {
    tag: IFormLookaheadTag
    tagId?: string | null,
    newContraints: Record<string, object>;
    status: LookaheadTagStatus,
    tagDate: string | null,
    duration: number | null,
    isBatchCreate: boolean | null,
    row: number | null,
    newLocation: string | null

}



class LookaheadTagDialog extends Component<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = {
            tagId: null,
            tag: {
                tradeId: null,
                name: null,
                locationId: null,
                predecessorId: null,
                crewSize: 1,
                goal: null,
                status: LookaheadTagStatus.Todo,
                isMilestone: false,
            },
            duration: 1,
            tagDate: moment().format('l'),
            row: 0,
            newLocation: null
        }

    }

    componentDidMount() {
        const {
            tagToEdit,
            tagToEditId,
            tagDate,
            row
          } = this.props;

          if(!!tagToEdit) {
            this.state = {
              tagId: tagToEditId,
              tag: {
                tradeId: tagToEdit.tradeId,
                name: tagToEdit.name,
                locationId: tagToEdit.locationId,
                crewSize: !!tagToEdit.crewSize ? tagToEdit.crewSize : 1,
                goal: tagToEdit.goal,
                status: tagToEdit.status,
                isMilestone: !!tagToEdit.isMilestone ? tagToEdit.isMilestone : null,
              }
            }
          } else {
              
              this.state = {
                tagDate,
                row
              }
          }


    }

    

    componentDidUpdate(prevProps, prevState, snapshot) {

        

    }
    shouldComponentUpdate(nextProps: Props, nextState: State) {

        if (!nextProps.tagToEditId && !!this.props.tagToEditId) {
        
            nextState.tag = {
                tradeId: null,
                name: "",
                locationId: null,
                predecessorId: null,
                crewSize: 1,
                goal: "",
                status: LookaheadTagStatus.Todo,
                isMilestone: null,
            }
        
        }

        if(!!nextProps.tagToEdit && !_.isEqual(nextProps.tagToEditId, this.props.tagToEditId)) {
            if (!!nextProps.tagToEdit) nextState.tag = nextProps.tagToEdit

            if(!!nextState.tag && !nextState.tag.status) {
                nextState.tag.status = LookaheadTagStatus.Todo
            }
            return true
        }

        if(nextProps.tagDate !== this.props.tagDate && nextProps.row !== this.props.row) {
            nextState = {
                tagDate: nextProps.tagDate,
                row: nextProps.row,
                isBatchCreate: true
            }

            return true
        }
    
        
    
        if(!_.isEqual(nextState.tag, this.state.tag))  {
            return true
        }

        if(this.props.isLookaheadTagDialogOpen !== nextProps.isLookaheadTagDialogOpen) {
            nextState.tag = {
                tradeId: null,
                name: "",
                locationId: null,
                predecessorId: null,
                crewSize: 1,
                goal: "",
                status: LookaheadTagStatus.Todo,
                isMilestone: false,
            }
            return true
        }

        if(nextState.isBatchCreate !== this.state.isBatchCreate) {
            return true
        }

        if(nextState.tagDate !== this.state.tagDate) {
            return true
        }

        if(nextState.row !== this.state.row) {
            return true
        }

        
        if(this.state.newLocation !== nextState.newLocation) {
            return true
        }
    
    
        return false
    }

    async closeDialog() {
        const { closeTagDialogValue } = this.props
        closeTagDialogValue()
    }

    async onTradeChanged(value: any) {
        const tag = { ...this.state.tag }
        tag.tradeId = value.value
        this.setState({
            tag
        });
    }

    async onPredecessorChanged(value: any) {
        const tag = { ...this.state.tag }
        tag.predecessorId= value.value
        this.setState({
            tag
        });
    }  

    async onCrewSizeChange(event: any) {
        const tag = { ...this.state.tag }
        tag.crewSize = parseInt(event.target.value)
        this.setState({
            tag
        });
    }

    onDurationChange = async (event: any) => {
        const duration = parseInt(event.target.value)
        this.setState({
            duration
        });
    }

    async onNameChange(event: any) {
        const tag = { ...this.state.tag }
        tag.name = event.target.value
        this.setState({
            tag
        });
    }

    async onGoalChange(event: any) {
        const tag = { ...this.state.tag }
        tag.goal = event.target.value
        this.setState({
            tag
        });
    }

    async onMilestoneChange(event: any) {
        const tag = { ...this.state.tag }
        tag.isMilestone = !tag.isMilestone
        this.setState({
            tag
        });
    }

    onBatchCreateChange = async () => {
        const isBatchCreate = !this.state.isBatchCreate
        if(!isBatchCreate) {
            this.setState({
                tagDate: moment().format('l'),
                row: 0,
                duration: 1,
                isBatchCreate
            });
        } else {
            this.setState({
                isBatchCreate
            });
        }
        
    }

    canMakeTag = () => {
        const { tag } = this.state
        const { userTrades, isAdmin } = this.props

        let canMove = false;

        if (isAdmin) {
            canMove = true;
        }

        if (!!userTrades && !!tag.tradeId && !isAdmin) {
            canMove = userTrades.has(tag.tradeId);
        }
        return canMove;
    
    }

    async onSubmit() {
        const { tag, isBatchCreate, tagDate, duration, row } = this.state
        const { submitTagValue, tagToEditId, errorAlert } = this.props


        if(!tag.tradeId || !tag.name || !tag.locationId || tag.crewSize < 0) {
            errorAlert('Fill Required Fields')
            return 
        }

        if(!this.canMakeTag()) {
            errorAlert('You Can\'t Modify This Trade')
            return
        }


        if(!isBatchCreate) {
            submitTagValue(tag, {}, tagToEditId)
        } else {
            if(!!tagDate && !!duration && row != null && row >= 0) {
                submitTagValue(tag, {}, tagToEditId, tagDate, row, duration)
            }
        }
        this.setState({
            newLocation: null,
            isBatchCreate: false,
        })
        this.closeDialog()
    }

    async onSubmitIsMilestone() {
        const { tag } = this.state
        const { submitTagValueIsMilestone, tagToEditId, errorAlert } = this.props


        if( !tag.name) {
            errorAlert('Fill Required Fields: Name')
            return 
        }
        
        submitTagValueIsMilestone(tag, {}, tagToEditId)
        this.closeDialog()
    }    

    async onLocationChanged(value:any) {
        const tag = { ...this.state.tag }
        const { tagLocationsSelectList } = this.props

        const locationId = value.value

        tag.locationId = locationId

        this.setState({
            tag,
            newLocation: !!(tagLocationsSelectList.find(location => location.uid == locationId)) ? null : locationId
        });
    }

    getColor() {
        const { trades } = this.props
        const { tag } = this.state

        if(!tag.tradeId) {
            return '#000'
        }

        const trade = trades[tag.tradeId]

        return !!trade ? trade.color :  '#000'
    }

    getLookaheadStatusList = () => {
        return Object.entries(LookaheadTagStatus).map(([key,value]) => {
            return {
                uid: key,
                name: value
            }
        })
    }

    onStatusChanged = (value: any) => {
        const tag = { ...this.state.tag }
        tag.status = value.value
        this.setState({
            tag
        })
    }

    handleDateChange = (value: Moment) => {

        const date = value.format('l')
        this.setState({
            tagDate: date
        })
    }

    renderDurationSection = () => {

        const { isNewTag, classes } = this.props
        const { tag, isBatchCreate } = this.state

        if(!isNewTag || (!!tag && !!tag.isMilestone)) {
            return 
        }

        return (
            <React.Fragment>
                <div className={classes.DialogFormField}>
                    <p className={classes.DialogFormLabel}>Batch Create?</p>
                    <Checkbox
                        onChange={this.onBatchCreateChange.bind(this)}
                        defaultValue={isBatchCreate}
                        checked={isBatchCreate}
                        color="primary"
                        className={classes.DialogFormIsMilestone}
                    />
                </div>
            </React.Fragment>
        ) 
    }

    onRowChange = () => {
        const row = parseInt(event.target.value)
        if(row <= 0 ) {
            return
        }
        this.setState({
            row: row - 1
        });
    }

    renderBatchCreate = () => {

        const { isBatchCreate, duration, tagDate, row, tag } = this.state
        const { classes, isNewTag } = this.props

        if(!isNewTag || (!!tag && !!tag.isMilestone)) {
            return
        }

        if(!isBatchCreate) {
            return
        }

        return(
            <React.Fragment>
                <div className={classNames(classes.standardRow, classes.spacedRow)}>
                    <div className={classes.DialogFormField}>
                        <p className={classes.DialogFormLabel}>Date</p>
                        <DatePicker value={moment(tagDate, 'l')} onChange={this.handleDateChange} label="Date" />
                    </div>
                    <div className={classes.DialogFormField}>
                        <p className={classes.DialogFormLabel}>Row</p>
                        <TextField
                            onChange={this.onRowChange.bind(this)}
                            required
                            value={(row + 1)}
                            type="number"
                            fullWidth={false}
                        />
                    </div>
                </div>
                <div className={classes.DialogFormField}>
                    <p className={classes.DialogFormLabel}>Duration</p>
                    <TextField
                        onChange={this.onDurationChange.bind(this)}
                        required
                        defaultValue={duration}
                        type="number"
                        fullWidth={true}
                    />
                </div>
            </React.Fragment>
        )
    }


    getLocationList = () => {
        const { newLocation } = this.state
        if(!newLocation) {
            return this.props.tagLocationsSelectList
        } else {
            const selectListing = [...this.props.tagLocationsSelectList, {
                uid: newLocation,
                name: newLocation}
            ]

            return selectListing
        }
    }

    getTradeText = () => {
        const { tag } = this.state

        if(!!tag && !!tag.isMilestone) {
            return 'Trade'
        }
        return 'Trade*'
    }

    getLocationText = () => {
        const { tag } = this.state

        if(!!tag && !!tag.isMilestone) {
            return 'Location'
        }
        return 'Location*'
    }

    onEnter = () => {
        const { tagDate, row } = this.props
        if(!!tagDate && row != null && row != undefined) {
            const tagDateProp = moment(parseInt(tagDate, 10))
        
            this.setState({
                tagDate: tagDateProp.format('l'),
                row: parseInt(row, 10),
                isBatchCreate: true
            })
        } else {
            this.setState({
                tagDate: null,
                row: null,
                isBatchCreate: false
            })
        }
    }
    
    render() {
        const { isLookaheadTagDialogOpen, classes, tagToEdit } = this.props;
        const { tag, isBatchCreate } = this.state
        const color = this.getColor()

        return (
          <Dialog
            onEnter={this.onEnter}

            maxWidth='sm'
            fullWidth={true}
            open={!!isLookaheadTagDialogOpen}
            onBackdropClick={this.closeDialog.bind(this)}
          >
              <DialogContent>
                <div style={{backgroundColor: color}} className={classes.DialogFormTitle}>
                    <p className={classes.DialogFormTitleText}>
                        Lookahead Tag
                    </p>
                </div>
                <div className={classes.DialogFormContent} >
                    <div style={{alignItems: 'flex-start'}} className={classes.DialogFormField}>
                        <p className={classes.DialogFormLabel}>{this.getTradeText()}</p>

                        <SelectList
                            onChange={this.onTradeChanged.bind(this)}
                            title=''
                            isMulti={false}
                            optionList={this.props.tradesSelectList}
                            value={tag.tradeId}
                        />
                    </div>
                    <div className={classes.DialogFormField}>
                        <p className={classes.DialogFormLabel}>Task*</p>
                        <TextField
                            onChange={this.onNameChange.bind(this)}
                            required
                            defaultValue={tag.name}
                            fullWidth={true}
                        />
                    </div>
                    <div style={{alignItems: 'flex-start'}} className={classes.DialogFormField}>
                        <p className={classes.DialogFormLabel}>{this.getLocationText()}</p>

                        <SelectList
                            onChange={this.onLocationChanged.bind(this)}
                            createOption={true}
                            title=''
                            isMulti={false}
                            optionList={this.getLocationList()}
                            value={tag.locationId}
                        />
                    </div>
                    <div style={{alignItems: 'flex-start'}} className={classes.DialogFormField}>
                        <p className={classes.DialogFormLabel}>Status</p>

                        <SelectList
                            onChange={this.onStatusChanged.bind(this)}
                            title=''
                            isMulti={false}
                            optionList={this.getLookaheadStatusList()}
                            value={(!!tag.status && !!LookaheadTagStatus[tag.status]) ? tag.status : LookaheadTagStatus.Todo}
                        />
                    </div>
                    <div style={{alignItems: 'flex-start'}} className={classes.DialogFormField}>
                        <p className={classes.DialogFormLabel}>Predecessor</p>

                        <SelectList
                            onChange={this.onPredecessorChanged.bind(this)}
                            title=''
                            isMulti={false}
                            optionList={this.props.tagSelectList}
                            value={tag.predecessorId}
                        />
                    </div>
                    {
                        ((!tag.isMilestone && !isBatchCreate) ? (
                            <div className={classes.DialogFormField}>
                                <p className={classes.DialogFormLabel}>Crew Size</p>
                                <TextField
                                    onChange={this.onCrewSizeChange.bind(this)}
                                    required
                                    defaultValue={tag.crewSize}
                                    type="number"
                                    fullWidth={true}
                                />
                            </div>
                        ) : null)
                    }
                    <div className={classes.DialogFormField}>
                        <p className={classes.DialogFormLabel}>Goal</p>
                        <TextField
                            onChange={this.onGoalChange.bind(this)}
                            defaultValue={tag.goal}
                            fullWidth={true}
                        />
                    </div>
                    {
                        ((!isBatchCreate) ? (
                            <div className={classes.DialogFormField}>
                                <p className={classes.DialogFormLabel}>Is Milestone?</p>
                                <Checkbox
                                    onChange={this.onMilestoneChange.bind(this)}
                                    defaultValue={tag.isMilestone}
                                    checked={tag.isMilestone}
                                    color="primary"
                                    className={classes.DialogFormIsMilestone}
                                />
                            </div>
                        ) : null)
                    }
                    {this.renderDurationSection()}
                    {this.renderBatchCreate()}
                </div>
              </DialogContent>
              <DialogActions>
                <Button onClick={this.closeDialog.bind(this)} color="secondary"> Cancel </Button>
                <Button onClick={this.onSubmit.bind(this)}  color="primary"> Confirm </Button>
                
              </DialogActions>
          </Dialog>
        )
    }
    
}


export default LookaheadTagDialog
  


// WEBPACK FOOTER //
// ./src/components/Dialogs/LookaheadTagDialog.tsx